export default {"src":"/_next/static/media/beiersdorf.d156fad4.svg","height":62,"width":176,"blurWidth":0,"blurHeight":0};